/**
 * Created by comoon on 1/25/16.
 */

var React = require("react");

var _ = require("underscore");

var moment = require("moment");

var QuoteApplyForm = require("./QuoteApplyForm.jsx");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var QuoteStatus = require("../conf/quote-status");

var OrderStatus = require("../conf/order-status");

var OrderTarget = require("../conf/order-target");

var TripGrade = require("../conf/trip-grade");

var {ActionConstants, EventConstants} = require("../Constants");

var {object2class} = require("../util/clazz");

var {format} = require("../util/price");

var Countdown = require("../cutil/Countdown");

var Tip = require("../cutil/Tip");

var QuoteRecordList = require("./QuoteRecordList");


var CATEGORY_MIN = 1;
var CATEGORY_MAX = 7;
var CATEGORY_STEP = 1;
var SELLER_MIN = 6;
var SELLER_MAX = 4888;
var SELLER_STEP = 70;
var PRODUCT_MIN = 45;
var PRODUCT_MAX = 100000;
var PRODUCT_STEP = 1700;

var FRESH_QUOTE_INTERVAL =  120 * 1000;

/**
 *  按一定秒刷新询价列表
 */
var freshQuote = _.throttle(function () {

    Dispatcher.dispatch({type: ActionConstants.FRESH_QUOTE_RESULT_LIST});

},FRESH_QUOTE_INTERVAL);

module.exports = React.createClass({
    displayName: "QuoteApp",
    getInitialState(){
        var props = this.props;
        var trip = ALikeStore.get_tripBasicInfo();
        var userRole = trip.userRole || 0;  //1: 达人, 2: 小帮手,0: 其他
        return {
            isOpenLoadingLayer:false,
            form: true,
            collapsed: false,
            categories: CATEGORY_MIN,
            sellers: SELLER_MIN,
            products: PRODUCT_MIN,
            _switched: null,
            _refreshed: null,
            orderStatus: null,
            ordering: false,
            tripInfo: trip,
            userRole: userRole,
            commit: false
        }
    },
    handle_toggleCollapse(){
        var collapsed = !this.state.collapsed;
        this.setState({
            collapsed
        });
    },
    /**
     * 价格日历click事件
     * @param versionId
     */
    handle_selectVersion(versionId){

        Dispatcher.dispatch({
            type: ActionConstants.SWITCH_QUOTE_RECORD,
            data: {versionId}
        });
    },
    /**
     * 重新调整
     */
    handle_tweak(parame){

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        if(!quote){
            return
        }
        var commit = parame.commit || false;
        if( quote.grade === -1 ){
            quote.grade = 0
        }
        
        this.setState({form: true,commit: commit},function(){
            Dispatcher.dispatch({type: ActionConstants.TWEAK_QUOTE, data: quote});
        });
    },
    handle_order(){
        var self = this;

        window.bookDialog.init(function(){
            Dispatcher.dispatch({type: ActionConstants.ORDER});
            self.setState({ordering : true });
        })
    },
    handle_reorder(){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.buyUrl.pc;
        }

    },
    handle_orderPayment(orderId){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.orderUrl.pc + '?oid=' + orderId;
        }
    },
    componentWillMount(){
        Dispatcher.dispatch({type: ActionConstants.SEARCH_PORT_INFO});

        freshQuote();

        setInterval(freshQuote,FRESH_QUOTE_INTERVAL);

        ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.on(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.on(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM, this.on_selectedStartDate);

        ALikeStore.on(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);

    },
    componentDidMount(){
        var self = this;
        self.__categoryInterval = setInterval(function () {
            var categories = self.state.categories;
            categories = categories + CATEGORY_STEP;
            if (categories > CATEGORY_MAX) {
                categories = CATEGORY_MIN;
            }
            self.setState({categories});
        }, 3000);
        self.__sellerInterval = setInterval(function () {
            var sellers = self.state.sellers;
            sellers = sellers + SELLER_STEP;
            if (sellers > SELLER_MAX) {
                sellers = SELLER_MIN;
            }
            self.setState({sellers});
        }, 1000);
        self.__productInterval = setInterval(function () {
            var products = self.state.products;
            products = products + PRODUCT_STEP;
            if (products > PRODUCT_MAX) {
                products = PRODUCT_MIN;
            }
            self.setState({products});
        }, 1000);
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.off(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.off(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM, this.on_selectedStartDate);

        ALikeStore.off(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);

        clearTimeout(this.__categoryInterval);
        clearTimeout(this.__sellerInterval);
        clearTimeout(this.__productInterval);
    },
    handle_LoadingClose(){
        this.setState({
            isOpenLoadingLayer: false
        })
    },
    /**
     * poa显示日期和周几
     */
    handle_setWeekDay(){
        var quteItem = $(".quote-container-iml .qr-item.selected");
        if(quteItem.length){
            quteItem.eq(0).trigger("click");
        }
    },
    /**
     * 询价列表返回
     */
    on_retrieveRecordListComplete(){

        this.on_switchQuoteRecordComplete();

        setTimeout(()=>{
            this.handle_setWeekDay()
        },0)

    },
    /**
     * 切换询价选择后返回
     */
    on_switchQuoteRecordComplete(){

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        if( !quote ){

            return

        }

        var isExpired = quote.isExpired;

        var orderStatus = quote.orderStatus;

        var isForm = function () {

            var isQuote = ALikeStore.is_quote( ALikeStore.get_currentRecord() );

            return isExpired && ! isQuote && !orderStatus

        };

        if( quote.orderId===0 && quote.orderStatus!== OrderStatus.noOrder.code ){

            return;

        }

        this.setState({
            orderStatus: orderStatus,
            ordering: false,
            isExpired:isExpired,
            form: isForm(),
            categories: CATEGORY_MIN,
            sellers: SELLER_MIN,
            products: PRODUCT_MAX,
            _switched: new Date()
        });
    },
    on_quoteInvalid(info){
        Dispatcher.dispatch({
            type: ActionConstants.ALERT_QUOTE_BECOME_INVALID,
            data: info
        });
    },
    on_orderComplete(){
        // 未登录，弹出登录框
        if(ALikeStore.get_errorCode(ActionConstants.ORDER) == 900){
          try{
            $.cpWin.login();
          }catch(e){
          }  
        }

        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
          window.location.href = ALikeStore.get_confirmUrl().web;
        }else{
          //出错时，预定按钮重置
          this.setState({ordering : false });
        }
    },
    on_selectedStartDate(){
        this.handle_tweak({commit:true});

    },
    render(){

        var self = this;

        var state = this.state;

        var commit = state.commit;

        var trip = ALikeStore.get_tripBasicInfo();

        var form = state.form;

        var expired = false;

        var currentQuote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        if (!state._switched) {
            //如果没有使用过切换功能,则不设置

            currentQuote = null;
        }

        if (currentQuote) {

            expired = currentQuote.isExpired;
        }

        return (
            <div className="quote-container-iml">
                {
                    form ?
                        (<QuoteApplyForm commit={commit} formData={currentQuote} hasCar={trip.hasCar}
                                         renderContact={this.render_contact}
                                         expired={expired}/>) :
                        self.render_quoteConditionDetail()
                }
                {this.render_collapseIndicator()}
                <QuoteRecordList collapsed={state.collapsed} switched={ !!state._switched } />
            </div>
        );
    },
    /**
     * 判断询价状态,渲染
     */
    render_QuoteStatus: function(quote, version){
        var tripInfo = this.state.tripInfo;
        var userRole = this.state.userRole;

        //version.status = 0;
        //quote.isExpired = true;
        //quote.isAllMistake = true;

        //计算中
        if(+version.status === QuoteStatus.Calculating.code ){
            return this.render_quoteCalculating(quote, version);
        }

        //价格过期
        if(quote.isExpired ){
            return this.render_priceExpired(quote);
        }

        //全部缺货
        if(quote.isAllMistake){
            return this.render_mistake(quote, version);
        }

        //计算失败,需要询价
        if(+version.status === QuoteStatus.Fatal.code || !version.valid){
            return this.render_failed(quote, version);
        }

        //正常报价
        if(version.valid && (version.status===QuoteStatus.Normal.code || version.status===QuoteStatus.Mistake.code)){
            //计价
            if(quote.inquiryType==1) {
                return this.render_valuation(quote, version);

            }else{
                //报价
                return this.render_enquiry(quote, version);

            }
        }

        return null;

    },
    /**
     * 展开收起
     * @returns {*}
     */
    render_collapseIndicator(){

        var state = this.state;

        var quoteRecordList = ALikeStore.get_quoteRecordList();

        if (quoteRecordList.length === 0) {

            return null;
        }
        return (state.collapsed ?
            (<div className="toggle-quote-result expand" onClick={this.handle_toggleCollapse}>
                展开<i className="icon-indicator-arr-r-d"/>
            </div>) :
            (<div className="toggle-quote-result collapse" onClick={this.handle_toggleCollapse}>
                收起<i className="icon-indicator-arr-l-d"/>
            </div>));
    },
    /**
     * 结果详情,包括: 出行条件 / 报价(过期/结果) / 计价(价格日历/结果)
     * @returns {XML}
     */
    render_quoteConditionDetail(){
        var self = this;

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());

        // >0时有订单了..
        var orderStatus  = this.state.orderStatus;

        return (
            <div className="quote-record">
                {
                    !orderStatus ? (
                        this.render_QuoteStatus(quote, version)
                    ):(
                        this.render_orderStatus(quote, version)
                    )
                }
            </div>
        );
    },
    /**
         * 出行条件 detail > 条件
         * @param quote
         * @returns {XML}
         */
        render_quoteConditionList(quote){
            var trip = ALikeStore.get_tripBasicInfo();
            var carCnt  = trip.hasCar ? (`，<strong class="c-orange">${quote.carCnt}</strong> 辆车`) : null;
            return (
                <ul className="condition-list">
                    {
                        quote.grade === -1 ? null :(
                            <li className="condition-item">
                                <div className="content">{_.findWhere(TripGrade.list, {code: +quote.grade}).name}</div>
                            </li>
                        )
                    }
                    <li className="condition-item">
                        <div className="content">
                            出发日期：
                            <span className="c-orange">
                            {quote.buyDate !== "" ? quote.buyDate : quote.startDate}
                        </span>
                        </div>
                        <div className="content">
                            出发城市：<span className="c-orange">{quote.startCityName}</span>
                        </div>
                    </li>
                    <li>
                        <div className="content">
                            <strong className="c-orange">{quote.adtCnt}</strong> 成人，
                            <strong className="c-orange">{quote.chdCnt}</strong> 儿童，
                            <strong className="c-orange">{quote.roomCnt}</strong> 间房
                            <span dangerouslySetInnerHTML={{__html: carCnt}}></span>
                        </div>
                    </li>
                </ul>
            );
        },
        /**
         * 重新调整
         * @returns {XML}
         */
        render_tweak(){
            var self = this;
            return (
                <div className="c-link title" style={{cursor: 'pointer'}} onClick={self.handle_tweak}>
                    重新调整&nbsp;&nbsp;&gt;</div>
            );
        },
        render_quoteNotResult(){

            var self = this;
            var state = self.state;

        },
        /**
         * 计价-->价格日历
         * @param quote
         * @param version
         * @returns {XML}
         */
        render_priceTable(quote,version){

            var self = this;
            var trip = this.state.tripInfo;
            var inWhiteList = trip.inWhiteList || 0;
            var dataListLen = (quote && quote.priceCalenderDataList) ? quote.priceCalenderDataList.length : 0;
            return (
                <div className="price-table">
                    {_.map(_.range(0, dataListLen), function (order) {
                        var dayInfo = quote.priceCalenderDataList[order];

                        var date = moment(dayInfo.startDate);

                        if (!dayInfo || !dayInfo.versionId) {
                            return (
                                <div className="day-price" key={order}>
                                    <div>
                                        <span className="date">{date.format("MM-DD")}</span>
                                        &nbsp;<span className="day">{date.format("dd")}</span>
                                    </div>
                                    <span className="ask">计算中…</span>
                                </div>
                            );
                        }

                        var selected = false;
                        if( dayInfo.versionId ){

                            selected = dayInfo.versionId === version.versionId;

                        }else{

                            dayInfo.startDate === quote.startDate && (selected = true);

                        }

                        var dayPriceClazz = object2class({
                            "day-price": true,
                            "selected": selected
                        });
                        var isVersion = (dayInfo.versionId === version.versionId) ? true : false;
                        var lockClazz = object2class({
                            "lack": true,
                            "icon-indicator-lack-white": isVersion,
                            "icon-indicator-lack-gray": !isVersion
                        });

                        var tips = ""
                        if(+dayInfo.status === QuoteStatus.Fatal.code && inWhiteList){
                            tips = "除缺货商品外价格："+format(dayInfo.perPrice)+"（仅供内部使用，严禁泄露给用户）";
                        }
                        return (
                            <div className={dayPriceClazz} key={dayInfo.versionId + "-" + order}
                                 onClick={()=>{self.handle_selectVersion(dayInfo.versionId)}}
                                 data-startdate={dayInfo.startDate}
                            >
                                <div>
                                    <span className="date">{date.format("MM-DD")}</span>
                                    &nbsp;<span className="day">{date.format("dd")}</span>
                                </div>
                                <div>
                                    {
                                        (+dayInfo.status === QuoteStatus.Mistake.code) ?
                                            (
                                                (dayInfo.tips.length>0)?(
                                                    <Tip trigger={<i className={lockClazz}/>} enter>
                                                        {self.render_mistakeHint(dayInfo)}
                                                    </Tip>
                                                ):(
                                                    <i className={lockClazz}/>
                                                )
                                            ) : null
                                    }
                                    {
                                        (dayInfo.startDate === quote.startDate) ?
                                            (<span className="default-day">默认日期</span>) : null
                                    }

                                </div>
                                <div className="text-right">
                                    {
                                        (dayInfo.valid && +dayInfo.status!==QuoteStatus.Fatal.code) ?
                                            (<span className="price">￥{format(dayInfo.perPrice)}</span>) :
                                            (dayInfo.status === QuoteStatus.Calculating.code) ?
                                                (<span className="ask">计算中…</span>) : (
                                                <Tip trigger={<span className="ask">欢迎询价</span>} enter>
                                                    {self.render_quoteHint()}
                                                </Tip>
                                            )
                                    }
                                </div>
                            </div>
                        );
                    })}
                </div>
            )

        },
        /**
         * 计价/报价--->结果
         * @param quote
         * @param version
         * @returns {XML}
         */
        render_quoteResult(quote,version){

            var self = this;
            var state = self.state;
            var ordering = state.ordering;
            return (
                <div>
                    {
                        version.valid && +version.status !== QuoteStatus.Fatal.code ?
                            (<div className="version-op">
                                <div className="mod-price">
                                    <div>
                                        <strong className="f-l">人均：</strong>
                                        <span className="price f-xl">{format(version.perPrice)}</span>
                                        <span className="c-orange f-18">&nbsp;元</span>
                                    </div>
                                    <div>
                                        ( 总价：<span className="total-price f-18">￥{format(version.amount)}</span> )
                                    </div>
                                </div>
                                {(+version.status === QuoteStatus.Mistake.code) ? (
                                    <div className="error-msg">
                                        <i className="icon-indicator-tip-gray"></i>
                                        <a href="#priceUncontain" className="js-anchor"><span className="f-normal c-blue">&nbsp;&nbsp;此价格不包含以下旅行产品</span></a>
                                    </div>
                                ) : null}
                                <div>
                                    <div className="error-msg">{ALikeStore.get_errorMsg(ActionConstants.ORDER)}</div>
                                    {
                                        !ordering ? (
                                            <button className="btn btn-orange" onClick={self.handle_order}>开始预定</button>
                                        ) : (
                                            <button className="btn btn-orange" >预定中…</button>
                                        )
                                    }
                                    <a href="https://www.xcds.com.cn/topic/special/price_ratio/?rf=zhunaa" className="btn-blue btn-price-ratio magic-elment" target="_blank">
                                        <i className="icon icon-super-detail-price-ratio"></i>
                                        全网比价，超全攻略
                                    </a>
                                </div>
                                <div className="count-down">计价剩余有效时间:&nbsp;
                                    <Countdown onInvalid={self.on_quoteInvalid}
                                               data={quote}
                                               left={ALikeStore.get_recordInvalidSeconds(quote.inquiryKey)}
                                               minuteText="分"/>
                                </div>
                            </div>) : null
                    }
                </div>
            )
        },
        /**
         * 联系方式
         * @returns {XML}
         */
        render_contact(isShowTel, isShowIM){
            var isShowTel = isShowTel || false;
            var isShowIM = isShowIM || false;
            return (
                <div className="contact magic-elment">
                    {isShowTel? (
                        <div className="vm-wrapper tel">
                            <i className="icon-indicator-tel"/>
                            <span>&nbsp;&nbsp;4006-86-5060</span>
                        </div>
                    ) : null}

                    {isShowIM ? (
                        this.render_im()
                    ): null}
                </div>
            );
        },
        /**
         * 报价过期
         * @param expired     * @returns {XML}
         */
        render_submit(expired){

            var state = this.state;

            return (
                <div className="expired">
                    <div className="op-feed">
                        {expired ? (
                            <div className="strong-hint">
                                价格已过期
                            </div>
                        ) : null}
                        <div>
                            <span><i className="icon-indicator-att"/>&nbsp;&nbsp;因为机票的价格会有波动，为了保证客户不受损失，报价有严格有效时间。</span>
                        </div>
                    </div>
                    {this.render_contact()}
                </div>
            )
        },
        /**
         * 计价提示
         * @returns {XML}
         */
        render_quoteHint(){
            return (
                <div className="c-tip-content quote-hint-box">
                    <div className="c-head">
                        <i className="icon-indicator-sigh"/>
                        询价提示
                    </div>
                    <div className="c-body">
                        <div>
                            为了保证价格真实有效，当日价格需要申请实时询价。
                            你可拨打4006-86-5060或在线出询价要求。
                        </div>
                        <div className="methods">
                            <div className="method m1">
                                <div className="title">
                                    <span className="hint">方式01</span>
                                    <span>&nbsp;:&nbsp;</span>
                                    <span>在线咨询</span>
                                </div>
                                {this.render_im()}
                            </div>
                            <div className="method m2">
                                <div className="title">
                                    <span className="hint">方式02</span>
                                    <span>&nbsp;:&nbsp;</span>
                                    <span>在线咨询</span>
                                </div>
                                <div className="vm-wrapper tel">
                                    <i className="icon-indicator-tel"/>
                                    <span>&nbsp;&nbsp;4006-86-5060</span>
                                </div>
                            </div>
                        </div>
                        <div className="note">
                            ＊询价结果将会第一时间发送到你的手机或在登录页面刷新后
                        </div>
                    </div>
                </div>
            );
        },
        render_mistakeHint(dayInfo){
            var tips = dayInfo.tips;
            if(tips.length == 0){
                return;
            }
            return(
                <div className="quote-lack-info">
                    <label className="title c-blue"><i className="icon-indicator-sigh"></i>&nbsp;&nbsp;该日期缺少产品</label>
                    <ul className="lack-list">
                        {
                            _.map(tips, function(item,index){
                                return(
                                    <li className="lack-item" key={index}>
                                        <div className="lack-txt"><i className="icon-indicator-lack-gray"></i>&nbsp;&nbsp;<span dangerouslySetInnerHTML={{__html: item}}></span></div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            )
        },
        /**
         * 已提交计算中
         */
        render_quoteCalculating: function(quote, version){
            var self = this;
            var state = self.state;
            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>
                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        <div className="version-op">
                            <div>
                                <img src="//f6.jiejiatech.net/y16/0607/1038/00bpi_o.gif" width="240" height="166" alt=""/>
                            </div>
                            <div className="calculating-hint">
                                行程大师正在对
                                <span className="c-orange">{self.state.categories}</span>
                                大品类的
                                <span className="c-orange">{self.state.sellers}</span>
                                家认证商户，
                                <span className="c-orange">{self.state.products}</span>
                                件产品进行实时比价和计算，全力为您提供更高的性价比。您无需在当前网页等待，
                                <span className="c-orange">4小时内</span>
                                会短信提醒您查看计价结果，点击短信中的链接即可进入本页查看价格结果，请注意查看短信。
                            </div>
                            <div className="status-info f-normal">正在实时比价、计价中，请等待短信通知，若有任何问题请咨询旅行顾问</div>
                            {self.render_contact(true, true)}
                        </div>
                    </div>
                </div>
            )
        },

        /**
         * 计算完成-全部缺货,
         */
        render_mistake: function(quote, version){

            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>

                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        <div className="version-op">
                            <div className="strong-hint">欢迎询价</div>
                            <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;该出发日期缺少
                                <a href="#priceUncontain" id="link-key" className="js-anchor">关键产品</a>，将会影响行程安排，请联系旅行顾问询价</div>
                            {this.render_contact(true, true)}
                        </div>
                    </div>
                </div>
            )
        },
        /**
         * 价格过期失效
         * @param expired
         * @returns {XML}
         */
        render_priceExpired(quote){

            var state = this.state;
            return (
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>
                    <div className="calc-status">
                        <div className="version-op b-top">
                            <div className="strong-hint">价格已过期</div>
                            <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;因为机票等旅行产品价格波动，为保证获得最佳价格，请重新计价</div>
                            {this.render_contact(true, true)}
                        </div>
                    </div>
                </div>
            )
        },
        /**
         * 计算失败,需要询价
         */
        render_failed: function(quote, version){

            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>
                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        <div className="version-op">
                            <div className="strong-hint">欢迎询价</div>
                            <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;出发日期缺少
                                <a href="#priceUncontain" id="link-key" className="js-anchor">关键产品</a>，将会影响行程安排，请联系旅行顾问询价</div>
                            {this.render_contact(true, true)}
                        </div>
                    </div>
                </div>
            )
        },

        /**
         * 计价--正常
         */
        render_valuation: function(quote, version){
            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>
                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        {this.render_quoteResult(quote, version)}

                        <div className="version-op b-top">
                            <div className="f-l">本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</div>
                            {this.render_contact(false ,true)}
                        </div>
                    </div>
                </div>

            )
        },
        /**
         * 报价--正常
         */
        render_enquiry: function(quote, version){
            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                        {this.render_tweak()}
                    </div>
                    <div className="calc-status">
                        {this.render_quoteResult(quote, version)}
                        <div className="version-op b-top">
                            <div className="f-l">本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</div>
                            {this.render_contact(false ,true)}
                        </div>
                    </div>
                </div>
            )
        },

        render_question: function(){
            return (
                <div className="status-info f-normal status-question">
                    <i className="icon-indicator-tip-gray"></i>
                    <span>本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</span>
                </div>
            )
        },

        /**
         * 报价/记价状态
         * @param quote
         * @param version
         * @returns {XML}
         */
        render_orderStatus(quote, version){
            var self = this;
            return(
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                    </div>
                    <div className="calc-status">
                        {this.render_orderDetail(quote, version)}

                        <div className="version-op b-top">
                            {self.render_question()}
                            {self.render_contact(true, true)}
                        </div>
                    </div>
                </div>
            )
        },
        /**
         * 报价/记价状态--->结果
         * @param quote
         * @param version
         * @returns {XML}
         */
        render_orderDetail(quote,version){

            var self = this;
            var state = self.state;
            return (
                <div>
                    {
                        version.valid && +version.status !== QuoteStatus.Fatal.code ?
                            (<div className="version-op">
                                <div className="mod-price">
                                    <div>
                                        <strong className="f-l">人均：</strong>
                                        <span className="price f-xl">{format(version.perPrice)}</span>
                                        <span className="c-orange f-18">&nbsp;元</span>
                                    </div>
                                    <div>
                                        ( 总价：<span className="total-price f-18">￥{format(version.amount)}</span> )
                                    </div>
                                </div>
                                <div>
                                    {self.render_orderButton(quote)}
                                </div>
                            </div>) : null
                    }

                </div>
            )
        },
        /**
         * 渲染状态
         * @param quote
         * @returns {XML}
         */
        render_orderButton(quote){
            var self = this;
            var state = self.state;
            var orderStatus  = state.orderStatus;
            //var orderStatus  = 4
            //console.log("订单状态3...",orderStatus)
            return(
                <div>

                    {(() => {
                        switch (orderStatus) {

                            case OrderStatus.waitingForPay.code:
                                return (
                                    <span>
                                    <button className="btn btn-orange" onClick={ ()=>{self.handle_orderPayment(quote.orderId)}}>已下预定单，立即付款</button>
                                    <br/>
                                    <button className="btn btn-default bt-reorder" onClick={self.handle_reorder }>关闭已下预定单</button>
                                </span>
                                );
                                break;

                            case OrderStatus.partPayed.code:

                                return(
                                    <div>
                                        <div className="strong-hint">已付定金</div>
                                        <button className="btn btn-orange" onClick={ ()=>{self.handle_orderPayment(quote.orderId)}}>支付尾款</button>
                                    </div>
                                );
                                break;

                            case OrderStatus.fullPayed.code:
                                return(
                                    <div>
                                        <div className="strong-hint">已付全款</div>
                                        <button className="btn btn-orange"  onClick={ self.handle_reorder }>查看订单状态</button>
                                    </div>
                                )
                                break;

                            case OrderStatus.tradeClose.code:
                                return(
                                    <div>
                                        <div className="strong-hint">交易关闭</div>
                                        <button className="btn btn-orange" onClick={ self.handle_reorder }>查看订单状态</button>
                                    </div>
                                )
                                break;

                            default:
                                return null;
                        }
                    })()}
                </div>
            )
    },
    /**
     * 渲染IM按钮
     * @returns {XML}
     */
    render_im(){
        var trip = this.state.tripInfo;
        var chatId  = trip.chatId || 0;
        var chatUser  = trip.chatUser || 0;
        var dataId = chatId ? chatId : chatUser;
        return(
            <div>
                {!chatId ? (
                    <i className="icon-btn-talk webim-online-click tl-im" data-id={dataId}/>
                ): (
                    <i className="icon-btn-talk webim-groupchat-link tl-im" data-chatid={dataId}/>
                )}
            </div>
        )
    }
});
 



/** WEBPACK FOOTER **
 ** ./script/detail/QuoteApp.jsx
 **/